import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import APIAccessLayer from "../components/APIAccessLayer";


const AddUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="API Access" />

        {/* APIAccessLayer */}
        <APIAccessLayer />


      </MasterLayout>
    </>
  );
};

export default AddUserPage;
